"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _lodash = _interopRequireDefault(require("lodash"));
var DesktopContainer = _styledComponents["default"].div.withConfig({
  displayName: "rangeLabel__DesktopContainer"
})(["display:flex;flex-direction:row;width:100%;> div{display:flex;width:33%;color:#404040;line-height:1.5em;}> div:last-child{justify-content:flex-end;text-align:right;margin-left:auto;}@media only screen and (max-width:760px){display:none}"]);
var MobileLabel = _styledComponents["default"].div.withConfig({
  displayName: "rangeLabel__MobileLabel"
})(["display:none;@media only screen and (max-width:760px){display:block;width:100%;margin:3px 0;}"]);
var RangeLabel = function RangeLabel(props) {
  return _lodash["default"].isEmpty(props.children) ? /*#__PURE__*/_react["default"].createElement(DesktopContainer, null, /*#__PURE__*/_react["default"].createElement("div", null, props.min_label), /*#__PURE__*/_react["default"].createElement("div", null, props.max_label)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(MobileLabel, null, props.min_label), props.children, /*#__PURE__*/_react["default"].createElement(MobileLabel, null, props.max_label));
};
RangeLabel.defaultProps = {
  min_label: "",
  max_label: ""
};
RangeLabel.propTypes = {
  min_label: _propTypes["default"].string,
  max_label: _propTypes["default"].string
};
var _default = exports["default"] = RangeLabel;